import React from 'react'
import styles from './styles.module.scss'
import $ from "jquery";

const InfoBlock = ({ setActivePopUp }) => {

  const scrollToForm = () => {
    let btop = $("#form").offset().top - $('#root .layout_header').offset().top - 80
    $("html").animate({
      scrollTop: btop
    }, 2000);
  }

  const scrollToDirections = () => {
    let btop = $("#directions-intern-ships").offset().top - $('#root .layout_header').offset().top - 80
    $("html").animate({
      scrollTop: btop
    }, 2000);
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.leftSide_wrap}>
        <div className={styles.leftSide}>
          <p className={styles.title}>Попробуй себя в профессии, где важна каждая деталь</p>
        </div>
      </div>

      <div className={styles.rightSide}>
        <div className={styles.rightSide_wrap}>
          <p className={styles.text}>Стажировки в Generium</p>
          <p className={styles.subtext}>Получи реальный опыт работы ещё до окончания вуза. На стажировке в компании тебя ждут интересные задачи,
            новейшее оборудование и общение с опытными наставниками.</p>
          {/* <button onClick={() => scrollToForm()}>
            Подать заявку <span>&rarr;</span>
          </button> */}

          <p className={styles.subtext_color}>Сбор заявок на стажировки 2026 года завершился 20 марта 2026 г. Заявки на стажировки больше не принимаются.</p>
          {/* <button onClick={() => window.open('https://generium-champ.ru/', '_blank').focus()}>
            Подробнее о кейс-чемпионате <span>&rarr;</span>
          </button> */}
          <button onClick={() => scrollToDirections()}>
            Подробнее о стажировках 2026 <span>&rarr;</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default InfoBlock
